/**
 * @title ziphelper.js: helper methods
 * @description This module contains helper methods 
 * @dependency 
 */
define([], function() {	
	
	var ziphelper = {
			
	    setLocationCookie : function(locationVal) {
		   $.cookie('C_LOC', locationVal);
		},	 
    
		setZipCookie : function(zipVal){
			$.cookie('WC_BD_ZIP', zipVal);
		},
		
		fmtZipOnEnter : function(element,event) {
			var charCode;
		    if(event && event.which){
		        charCode = event.which;
		    }else if(window.event){
		    	event = window.event;
		        charCode = event.keyCode;
		    }
		    if(charCode == 13) {
		        // Do your thing here with element
		    	zipCode= ziphelper.formatZipCode(element.value);
		    	document.getElementById(element.id).value = zipCode;
		    }
		},
		
		fmtZipKeyUp : function(element,event) {
			var form = $(event.target).closest('form');			
			var isValid = form.valid();
			if (isValid==false){				
				var errorHolder = form.find("[critical-notification-holder]");
				errorHolder.addClass("hidden");				
			}			 
		},
		
		formatZipCode : function(zipCode) {
			var fomatedZipcode = zipCode;
			if($('#zipFormatterFlag')){
				var formatFlag= document.getElementById("zipFormatterFlag").getAttribute("value");
				if(formatFlag == 'true'){
					fomatedZipcode = zipCode.split(' ').join('');
					fomatedZipcode = fomatedZipcode.toUpperCase();
					fomatedZipcode = fomatedZipcode.replace(/^(.{3})(.*)$/, "$1 $2");
				}
			}
			return fomatedZipcode.length > 10 ? zipCode : fomatedZipcode;
		}
		
	}
	// Expose ziphelper to the global scope.
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.ziphelper = ziphelper;
		
	return ziphelper;
    
});


// WEBPACK FOOTER //
// ./js/deliveryzipcode/ziphelper.js